module.exports = NewsTicker = function(el){
  this.element = $(el);
  this.event();
};
NewsTicker.prototype.event = function(){
  var self = this;

  var len = this.element.find('li').length, i = 1, ticker;

  function news(){
    self.element.find('li').removeClass('is-visible');
    self.element.find('li:nth-child('+i+')').addClass('is-visible');
    i++;
    if(i>len){
      i = 1;
    }
    ticker = setTimeout(news, 6000);
  }
  news();

  this.element.find('li').hover(function(){
    clearTimeout(ticker);
  }, function(){
    news();
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/_modules/newsTicker.js
// module id = 8
// module chunks = 0